import { Observable } from 'rxjs';
import { SelectData } from './select-input.model';

export enum FormInputType {
  TEXT = 'TEXT',
  SELECT = 'SELECT',
  RADIO = 'RADIO',
  DATE = 'DATE',
  CHECKBOX = 'CHECKBOX',
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  CURRENCY = 'CURRENCY',
  DIVISOR = 'DIVISOR',
  SUBDIVISOR = 'SUBDIVISOR',
  NUMBER = 'NUMBER',
  CEP = 'CEP',
}

export interface FormInput {
  name: string;
  type: FormInputType;
  formControlName?: string;
  value?: unknown;
  required?: boolean;
  select?: Observable<SelectData[]>;
  mask?: string;
  radios?: { name: string; value: unknown; checked?: boolean }[];
  isEmail?: boolean;
  class?: string;
  minDate?: Date;
  maxDate?: Date;
  multiple?: boolean;
  hint?: string;
  errorMessage?: string;
}
